import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import router from './router'
import store from './store/store'

/**
 * 引入样式
 */
import 'normalize.css' // 样式重置
import './assets/style/global.scss' // 全局样式

/**
 * 引入脚本
 */
import core from './assets/js/core' // 框架基础功能
import VConsole from 'vconsole'
// import './assets/js/api-dev' // 模拟接口，生产环境需要注释掉
import {
  Icon,
  Dialog,
  Collapse,
  CollapseItem,
  DatetimePicker,
  List,
  PullRefresh,
  Cell,
  Loading,
  Popup,
  Divider,
  Calendar
} from 'vant'
import 'vant/lib/index.css'
// 添加钉钉环境验证
import * as dd from 'dingtalk-jsapi'
import apiService from './assets/js/api'
/**
 * 扩展Vue
 */
Vue.prototype.$eventBus = new Vue({}) // 全局事件总线
// Vue.prototype.$request = core.request // 异步请求服务

Vue.config.productionTip = false
Vue.use(Icon)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(DatetimePicker)
Vue.use(Popup)
Vue.use(List)
  .use(PullRefresh)
  .use(Cell)
  .use(Loading)
  .use(Dialog)
  .use(Divider)
  .use(Calendar)

let corpId = ''
let authCode = ''
window.dingToken = ''
window.loginId = ''

// 当dd应用加载完成，先从后台获取corpId,然后在获取用户的authCode,再把authCode发送给后台，获取dingToken
async function getUserCropId () {
  const { __statusCode, data } = await apiService.getDataFromInterface(
    apiService.getUserCropId
  )
  if (__statusCode === '1') {
    corpId = data.corpId
    // dd.ready参数为回调函数，在环境准备就绪时触发，jsapi的调用需要保证在该回调函数触发后调用，否则无效。
    dd.runtime.permission.requestAuthCode({
      corpId: corpId,
      onSuccess: function (result) {
        authCode = result.code
        getUserToken()
      },
      // eslint-disable-next-line
      onFail: function (err) {
        alert('用户信息验证失败，请重新登录！')
      }
    })
  }
}

async function getUserToken () {
  const { __statusCode, data } = await apiService.getDataFromInterface(
    apiService.getUserDingToken + '?authCode=' + authCode
  )
  if (__statusCode === '1') {
    window.dingToken = data.dingToken
    window.loginId = data.loginId
    window.serverVersion = data.serverVersion
    if (process.env.NODE_ENV === 'development') {
      window.serverVersion = data.serverVersion
      isAuthority()
    } else {
      isAuthorityDD()
    }
  }
}
async function isAuthority () {
  const { __statusCode, data } = await apiService.getDataFromInterface(
    apiService.getAuth
  )

  if (__statusCode === '1') {
    console.log(data)
    if (data.length === 0) {
      //
      var r = confirm('当前用户无权限，请退出')
      if (r === true) {
        dd.ready(function () {
          dd.biz.navigation.close()
        })
      } else {
        dd.ready(function () {
          dd.biz.navigation.close()
        })
      }
    } else {
      if (data.includes('GWM_DD_JYFX_NEWS')) { // 资讯模块
        sessionStorage.setItem('authNews', true)
      }
      if (data.includes('GWM_DD_JYFX_YX')) { // 营销模块
        sessionStorage.setItem('authMarket', true)
      }
      if (data.includes('GWM_DD_JYFX_YX_HW')) { // 营销-海外模块
        sessionStorage.setItem('authMarketAbroad', true)
      }
      if (data.includes('GWM_DD_JYFX_CW')) { // 财务模块
        sessionStorage.setItem('authFinance', true)
      }
      if (data.includes('GWM_DD_JYFX_SC')) { // 资讯模块
        sessionStorage.setItem('authProduction', true)
      }
      if (data.includes('GWM_DD_JYFX_HH')) { // 红黑榜模块
        sessionStorage.setItem('authRank', true)
      }
      if (data.includes('GWM_DD_JYFX_BD')) {
        sessionStorage.setItem('authScoreList', true)
      }
      new Vue({
        router,
        store,
        render: h => h(App)
      }).$mount('#app')
    }
  }
}
async function isAuthorityDD () {
  const { __statusCode, data } = await apiService.getDataFromInterface(
    apiService.getAuth
  )
  if (__statusCode === '1') {
    if (data.length === 0) {
      //
      // dd.device.notification.alert({
      //   message: '当前用户无权限，请退出',
      //   title: '提示', // 可传空
      //   buttonName: '退出',
      //   onSuccess: function () {
      //     dd.biz.navigation.close()
      //   },
      //   onFail: function () {
      //     dd.biz.navigation.close()
      //   }
      // })
      Dialog.alert({
        title: '提示',
        message: '当前用户无权限，请退出'
      }).then(() => {
        // on close
        dd.biz.navigation.close()
      })
    } else {
      // 将权限内容存到sessionStory
      if (data.includes('GWM_DD_JYFX_NEWS')) { // 资讯模块
        sessionStorage.setItem('authNews', true)
      }
      if (data.includes('GWM_DD_JYFX_YX')) { // 营销模块
        sessionStorage.setItem('authMarket', true)
      }
      if (data.includes('GWM_DD_JYFX_YX_HW')) { // 营销-海外模块
        sessionStorage.setItem('authMarketAbroad', true)
      }
      if (data.includes('GWM_DD_JYFX_CW')) { // 财务模块
        sessionStorage.setItem('authFinance', true)
      }
      if (data.includes('GWM_DD_JYFX_SC')) { // 资讯模块
        sessionStorage.setItem('authProduction', true)
      }
      if (data.includes('GWM_DD_JYFX_HH')) { // 红黑榜模块
        sessionStorage.setItem('authRank', true)
      }
      if (data.includes('GWM_DD_JYFX_BD')) { // 榜单模块
        sessionStorage.setItem('authScoreList', true)
      }
      // 权限处理结束
      dd.ready(function () {
        dd.ui.webViewBounce.disable()

        // 如果是推送的链接判断是否要打开新闻详情页 始

        let urlObj = getQueryObject(location.href)
        if (urlObj.newsId) {
          store.commit('updateUrlNewsId', urlObj.newsId)
          store.commit('updataOpenNewsDetail', Number(urlObj.isFromNotice) === 1)
          store.commit('updataIsFromShare', Number(urlObj.isFromShare) === 1)
        }
        // 如果是推送的链接判断是否要打开新闻详情页 终
        new Vue({
          router,
          store,
          render: h => h(App)
        }).$mount('#app')
      })
    }
  }
}
function getQueryObject (url) {
  url = url == null ? window.location.href : url
  var search = url.substring(url.lastIndexOf('?') + 1)
  var obj = {}
  var reg = /([^?&=]+)=([^?&=]*)/g
  // [^?&=]+表示：除了？、&、=之外的一到多个字符
  // [^?&=]*表示：除了？、&、=之外的0到多个字符（任意多个）
  search.replace(reg, function (rs, $1, $2) {
    var name = decodeURIComponent($1)
    var val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}
if (process.env.NODE_ENV === 'development') {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
  getUserToken()
  new VConsole()
  sessionStorage.setItem('authNews', true)
  sessionStorage.setItem('authMarket', true)
  sessionStorage.setItem('authMarketAbroad', true)
  sessionStorage.setItem('authScoreList', true)
  sessionStorage.setItem('authFinance', true)
  sessionStorage.setItem('authProduction', true)
  sessionStorage.setItem('authRank', true)
} else {
  // getUserToken() //测试环境

  dd.ready(function () {
    // 开始用户认证

    getUserCropId()
  })
}
